import React from 'react';
import './App.css';
import ChatApp from './components/Chat';

function App() {
  return (
    <div className="App">
      <ChatApp />
    </div>
  );
}

export default App;